import React, { useContext } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';

import { DataTypeContext } from '../../DataTypes';

const AccountExists = () => {
    const { dataTypes } = useContext(DataTypeContext);
    const location = useLocation();

    const {
        questionPhrasing: { unclearMatchesText },
    } = dataTypes;
    const { t } = useTranslation();
    const isDefiniteMatch = location?.state?.definiteMatch;

    return (
        <Col md={6} sm={12} className="mx-auto text-center card shadow-sm rounded p-4">
            <h4 className="text-center">{t('account.exists.heading')}</h4>
            {isDefiniteMatch ? (
                <>
                    <p className="mb-4">{t('account.exists.text')}</p>
                    <div className="d-flex">
                        <Button as={Link} variant="outline-secondary" to="/reset-password" className="w-50 mr-2">
                            {t('user.forgotPassword')}
                        </Button>
                        <Button as={Link} variant="primary" to="/" className="w-50">
                            {t('account.exists.return')}
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    <p className="mb-4" dangerouslySetInnerHTML={{ __html: unclearMatchesText }}></p>
                    <div className="d-flex">
                        <Button as={Link} variant="primary" to="/" className="w-50 mx-auto">
                            {t('account.exists.return')}
                        </Button>
                    </div>
                </>
            )}
        </Col>
    );
};

export default AccountExists;
